import createModuleLogger from "../../infra/logger/createModuleLogger";
const appSettingsLogger = createModuleLogger("appSettings");
export default appSettingsLogger;
